(function () {
radaEnquiryListController.$inject = ['$rootScope', 'enquiryService'];
    angular
        .module('app.enquiry')
        .component('radaEnquiryList', {
            bindings: {
                enquiryId: '@',
                mainHeading: '@',
                subHeadingPartOne: '@',
                subHeadingPartTwo: '@',
                removeFromEnquiryText: '@'
            }, // components are limited to isolated scope
            templateUrl: '/client/app/enquiry/enquiry-list.html',
            controller: radaEnquiryListController
        });

/* @ngInject */
function radaEnquiryListController($rootScope, enquiryService) {
    var vm = this;
    vm.$onInit = function () {
        vm.enquiryItems = [];
        enquiryService.getEnquiryItems(vm.enquiryId)
        .then(function(response){
            vm.enquiryItems = response;
        });
    };

    vm.removeProduct = function(sku) {
        //Add this product via the service
        enquiryService.deleteProduct(vm.enquiryId, sku)
        .then(function(response) {
             $rootScope.$broadcast('product-removed', sku);
            vm.enquiryItems =  vm.enquiryItems.filter(function( obj ) {
                return obj.sku !== sku;
            }); 
        });
    };
}
})();